module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAA7UlEQVQokW3PvS4EYRiG4WvGFja2stF8EoextYpCCLptJBIbkWn3ADgH2xitKP0kjgCJiIOQYEJBtwp/ozArY8zTfff9fHnfN8rzXDW9bLAAaUjOqq7xr/2TFj7rRDSa0MsGTexjGifIsYo7rKchefv90MsGUVFaxBAX+MIsmjjFchqSPC4mbRVlmMABDosyLGEToo2H3RZu0S6tuoZx7JXYM2ZidCtlGMNHhbXRbRSHVfNSw2ClgU6NuEFcwzsxJivwPA1JlobkHpcVNxXjtQTe0S+9+/7eMoxxjEfsYD4NyfXIpiG5why28YSjb9M/PoIxxnDYAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/healthIcon/huxi-4.png
// module id = B3Nw
// module chunks = 4